(() => {
  if (window.__yyEnquiryReady) return;
  window.__yyEnquiryReady = true;

  const init = () => {
    const dialog = document.getElementById('YYEnquiryDialog');
    const config = document.getElementById('YYEnquiryConfig');
    const form = document.getElementById('YYEnquiryForm');
    if (!dialog || !config || !form) return;

    const cta = config.dataset.cta || 'Enquire now';
    const helper = config.dataset.helper || '';
    const sending = config.dataset.sending || 'Sending…';
    const fallbackProduct = config.dataset.productFallback || 'Product enquiry';
    // Restrict to 10 Indian mobile digits, including pasted input. Never log phone numbers.
    const phoneField = form.querySelector('input[name="phone"]');
    const sanitizePhoneInput = () => {
      if (!phoneField) return;
      let digits = phoneField.value.replace(/\D/g, '');
      phoneField.value = digits.slice(0, 10);
    };
    phoneField?.addEventListener('input', sanitizePhoneInput);
    const submitButton = form.querySelector('[data-yy-enquiry-submit]');
    const submitText = form.querySelector('[data-yy-enquiry-submit-text]');
    const submitLabel = submitText?.textContent?.trim() || 'Send enquiry';
    const productLabel = dialog.querySelector('[data-yy-enquiry-product-label]');
    const productInput = form.querySelector('[data-yy-enquiry-product]');
    const urlInput = form.querySelector('[data-yy-enquiry-url]');
    const variantInput = form.querySelector('[data-yy-enquiry-variant]');
    const sourceInput = form.querySelector('[data-yy-enquiry-source]');
    let currentContext = null;
    let pendingSubmission = null;
    let enhanceQueued = false;

    // Manual, preview-only diagnostics. No tracking runs until a user interacts.
    const queryParams = new URLSearchParams(window.location.search);
    // Shopify preview can drop preview_theme_id from the URL after setting a
    // preview cookie. This code is staged on the QA theme, so an explicit
    // debug query flag alone is enough to display the manual test panel.
    const yyDebugEnabled = queryParams.get('yy_enquiry_debug') === '1';
    let yyDebugStatus = null;
    const updateYyDebug = (name, result) => {
      if (!yyDebugStatus) return;
      yyDebugStatus.textContent = name + ' — ' + result;
    };

    // Consent-aware enquiry funnel events. A dispatched request is NOT a confirmed lead.
    // Use one existing GA4 transport; never load another Google tag or send form PII.
    const trackEnquiry = (eventName, context) => {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) {
        updateYyDebug(eventName, 'blocked: analytics consent not granted');
        return;
      }

      const sourcePath = window.location.pathname;
      let productPath = '';
      try { productPath = new URL(context?.url || '', window.location.origin).pathname; } catch (_) {}
      const sourceType = sourcePath.startsWith('/products/') ? 'product' : sourcePath.startsWith('/collections/') ? 'collection' : sourcePath.startsWith('/blogs/') ? 'blog' : sourcePath.startsWith('/search') ? 'search' : 'other';
      const isPreview = yyDebugEnabled || window.Shopify?.designMode === true || queryParams.has('preview_theme_id');
      const params = {
        yy_form_version: '2.3',
        yy_source_type: sourceType,
        yy_source_path: sourcePath,
        yy_product_path: productPath,
        yy_entrypoint: context?.entrypoint || 'other',
        ...(isPreview ? { debug_mode: true, yy_qa_preview: 'yes' } : {})
      };

      // GTM routes custom events by their dataLayer event name. A container
      // must have a corresponding GA4 Event tag to report those events.
      const hasGtm = !!(window.google_tag_manager && Object.keys(window.google_tag_manager).some(key => key.startsWith('GTM-')));
      if (hasGtm) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...params });
        updateYyDebug(eventName, 'GTM dataLayer event emitted; GA4 event tag required');
      } else if (typeof window.gtag === 'function') {
        try {
          window.gtag('event', eventName, params);
          updateYyDebug(eventName, 'sent to existing gtag; check GA4 DebugView');
        } catch (_) {
          updateYyDebug(eventName, 'gtag transport error');
        }
      } else {
        // Queued for a configured GTM listener; this alone does NOT deliver to GA4.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...params, yy_ga4_pending_transport: true });
        updateYyDebug(eventName, 'queued only; no GA4 transport detected');
      }
    };

    const makeButton = (kind) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'yy-enquire-trigger yy-enquire-trigger--' + kind + (kind === 'card' ? ' m-button m-button--white' : '');
      button.setAttribute('data-yy-enquire', '');
      button.setAttribute('aria-haspopup', 'dialog');

      const label = document.createElement('span');
      label.textContent = cta;
      button.append(label);

      if (kind !== 'card') {
        const arrow = document.createElement('span');
        arrow.textContent = '→';
        arrow.setAttribute('aria-hidden', 'true');
        button.append(arrow);
      }

      return button;
    };

    const addCardButton = (card) => {
      if (!card || card.querySelector('.yy-enquire-card-wrap')) return;
      const info = card.querySelector('.m-product-card__info') || card.querySelector('.m-product-card__content');
      if (!info) return;
      const wrap = document.createElement('div');
      wrap.className = 'yy-enquire-card-wrap';
      wrap.appendChild(makeButton('card'));
      info.appendChild(wrap);
    };

    const addMainButton = (wrapper) => {
      if (!wrapper || wrapper.querySelector('.yy-enquire-trigger')) return;
      wrapper.appendChild(makeButton('pdp'));
      if (helper && !wrapper.querySelector('.yy-enquire-helper')) {
        const note = document.createElement('span');
        note.className = 'yy-enquire-helper';
        note.textContent = helper;
        wrapper.appendChild(note);
      }
    };

    const addStickyButton = (wrapper) => {
      if (!wrapper || wrapper.querySelector('.yy-enquire-trigger')) return;
      wrapper.appendChild(makeButton('sticky'));
    };

    const enhance = () => {
      document.querySelectorAll('[data-yy-enquiry-cta][hidden]').forEach(element => { element.hidden = false; });
      document.querySelectorAll('.m-product-card').forEach(addCardButton);
      document.querySelectorAll('.main-product__block-buy_buttons .m-product-form--wrapper').forEach(addMainButton);
      document.querySelectorAll('product-form.m-product-form--main .m-product-form--wrapper').forEach(addMainButton);
      document.querySelectorAll('.m-sticky-addtocart .m-product-form__wrapper').forEach(addStickyButton);
    };

    const queueEnhance = () => {
      if (enhanceQueued) return;
      enhanceQueued = true;
      requestAnimationFrame(() => {
        enhanceQueued = false;
        enhance();
      });
    };

    const getContext = (trigger) => {
      const card = trigger.closest('.m-product-card');
      const productForm = trigger.closest('product-form');
      let title = '';
      let url = '';
      let variantId = '';
      const entrypoint = trigger.dataset.yyEntry || (card ? 'product_card' : trigger.closest('.m-sticky-addtocart') ? 'sticky_pdp' : 'product_page');
      const guidedUrl = trigger.dataset.yyProductUrl;
      const guidedTitle = trigger.dataset.yyProductTitle;
      if (guidedUrl && guidedTitle) {
        try {
          const resolved = new URL(guidedUrl, window.location.origin);
          if (resolved.origin === window.location.origin && /^\/(products|collections)\//.test(resolved.pathname)) {
            return { title: guidedTitle, url: resolved.href, variantId: '', source: window.location.href, entrypoint };
          }
        } catch (_) {}
      }

      if (card) {
        const titleLink = card.querySelector('.m-product-card__name');
        const mediaLink = card.querySelector('.m-product-card__link[href*="/products/"]');
        title =
          titleLink?.textContent?.trim() ||
          mediaLink?.getAttribute('aria-label')?.trim() ||
          '';
        url = titleLink?.href || mediaLink?.href || '';
      }

      if (!title) {
        title =
          trigger.closest('.m-sticky-addtocart')?.querySelector('.m-sticky-addtocart--title h3')?.textContent?.trim() ||
          document.querySelector('.template-product .m-product-title')?.textContent?.trim() ||
          document.querySelector('h1')?.textContent?.trim() ||
          fallbackProduct;
      }

      if (!url) url = window.location.href;

      const idField =
        productForm?.querySelector('select[name="id"]') ||
        productForm?.querySelector('input[name="id"]:not([disabled])') ||
        productForm?.querySelector('input[name="id"]');

      if (idField?.value) variantId = idField.value;

      try {
        const productUrl = new URL(url, window.location.origin);
        if (variantId) productUrl.searchParams.set('variant', variantId);
        url = productUrl.href;
      } catch (_) {}

      return { title: title || fallbackProduct, url, variantId, source: window.location.href, entrypoint };
    };

    const applyContext = (context) => {
      currentContext = context || { title: fallbackProduct, url: window.location.href, variantId: '', source: window.location.href };
      if (productLabel) productLabel.textContent = currentContext.title;
      if (productInput) productInput.value = currentContext.title;
      if (urlInput) urlInput.value = currentContext.url;
      if (variantInput) variantInput.value = currentContext.variantId || '';
      if (sourceInput) sourceInput.value = currentContext.source || window.location.href;
    };

    const resetFormState = () => {
      const optional = form.querySelector('.yy-enquiry-optional');
      if (optional) optional.open = false;
      const errorBox = form.querySelector('[data-yy-enquiry-errors]');
      const successBox = form.querySelector('[data-yy-enquiry-success]');
      const fields = form.querySelector('[data-yy-enquiry-fields]');
      const privacy = form.querySelector('[data-yy-enquiry-privacy]');

      form.reset();
      sanitizePhoneInput();

      if (fields) fields.hidden = false;
      if (privacy) privacy.hidden = false;
      if (successBox) successBox.hidden = true;
      if (errorBox) errorBox.hidden = true;
      if (submitButton) {
        submitButton.hidden = false;
        submitButton.disabled = false;
      }
      if (submitText) submitText.textContent = submitLabel;
    };

    const openDialog = (context) => {
      resetFormState();
      applyContext(context);
      trackEnquiry('yy_enquiry_open', currentContext);
      document.documentElement.classList.add('yy-enquiry-open');
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      const firstField = form.querySelector('input:not([type="hidden"])');
      if (firstField) setTimeout(() => firstField.focus({ preventScroll: true }), 80);
    };

    const closeDialog = () => {
      document.documentElement.classList.remove('yy-enquiry-open');
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      resetFormState();
      currentContext = null;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-yy-enquire]');
      if (trigger) {
        event.preventDefault();
        openDialog(getContext(trigger));
        return;
      }
      if (event.target.closest('[data-yy-enquiry-close]')) {
        event.preventDefault();
        closeDialog();
      }
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('yy-enquiry-open');
      resetFormState();
      currentContext = null;
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      if (!currentContext) {
        applyContext({ title: fallbackProduct, url: window.location.href, variantId: '', source: window.location.href });
      }

      trackEnquiry('yy_enquiry_submit_attempt', currentContext);
      const endpoint = config.dataset.endpoint?.trim();
      const errorBox = form.querySelector('[data-yy-enquiry-errors]');
      const successBox = form.querySelector('[data-yy-enquiry-success]');
      const fields = form.querySelector('[data-yy-enquiry-fields]');
      const privacy = form.querySelector('[data-yy-enquiry-privacy]');

      if (errorBox) errorBox.hidden = true;
      if (submitButton) submitButton.disabled = true;
      if (submitText) submitText.textContent = sending;

      const payload = {
        name: form.elements.name?.value?.trim() || '',
        phone: form.elements.phone?.value?.trim() || '',
        email: form.elements.email?.value?.trim() || '',
        location: form.elements.location?.value?.trim() || '',
        product: currentContext?.title || fallbackProduct,
        productUrl: currentContext?.url || window.location.href,
        variantId: currentContext?.variantId || '',
        sourcePage: currentContext?.source || window.location.href
      };

      const payloadKey = JSON.stringify(payload);
      if (pendingSubmission?.key !== payloadKey) {
        pendingSubmission = { key: payloadKey, id: window.crypto.randomUUID() };
      }
      payload.submissionId = pendingSubmission.id;

      try {
        if (!endpoint) throw new Error('Missing endpoint');

        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload),
          keepalive: true
        });

        const result = await response.json();
        if (!response.ok || result?.success !== true) {
          throw new Error('Enquiry save was not confirmed');
        }
        pendingSubmission = null;
        trackEnquiry('generate_lead', currentContext);
        if (fields) fields.hidden = true;
        if (submitButton) submitButton.hidden = true;
        if (privacy) privacy.hidden = true;
        if (successBox) successBox.hidden = false;
        form.reset();
      } catch (_) {
        trackEnquiry('yy_enquiry_request_error', currentContext);
        if (errorBox) errorBox.hidden = false;
        if (submitButton) submitButton.disabled = false;
        if (submitText) submitText.textContent = submitLabel;
      }
    });

    enhance();

    if (yyDebugEnabled) {
      const panel = document.createElement('aside');
      panel.id = 'YYEnquiryAnalyticsDiagnostics';
      panel.setAttribute('aria-label', 'YETI YOGI enquiry analytics QA');
      panel.style.cssText = 'position:fixed;bottom:90px;left:14px;z-index:2147483640;max-width:min(340px,calc(100vw - 28px));padding:14px;border:1px solid #cbd9ce;border-radius:12px;background:#f8faf6;color:#294436;font:12px/1.5 system-ui,sans-serif;box-shadow:0 8px 22px rgba(17,38,24,.12)';
      const heading = document.createElement('strong');
      heading.textContent = 'Enquiry analytics QA (preview only)';
      heading.style.cssText = 'display:block;font-size:13px;margin-bottom:5px';
      yyDebugStatus = document.createElement('div');
      yyDebugStatus.setAttribute('role', 'status');
      const consentFn = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed;
      const consentState = typeof consentFn === 'function'
        ? (consentFn.call(window.Shopify.customerPrivacy) ? 'allowed' : 'not allowed')
        : 'not initialized';
      yyDebugStatus.textContent = 'Analytics consent: ' + consentState + '. No event sent yet.';
      yyDebugStatus.style.cssText = 'margin:7px 0;word-break:break-word';
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = 'Send GA4 debug test event';
      button.style.cssText = 'cursor:pointer;background:#294436;color:white;border:0;border-radius:8px;padding:9px 12px;min-height:40px;font-weight:600';
      button.addEventListener('click', () => {
        trackEnquiry('yy_enquiry_debug_test', currentContext);
      });
      const note = document.createElement('p');
      note.textContent = 'Check GA4 DebugView for yy_enquiry_debug_test. This is not a confirmed lead.';
      note.style.cssText = 'margin:9px 0 0;font-size:11px;opacity:.8';
      panel.append(heading, yyDebugStatus, button, note);
      document.body.appendChild(panel);
    }

    const observer = new MutationObserver(queueEnhance);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', queueEnhance);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();